module.exports = __webpack_public_path__ + "static/media/gym.b978b718.jpg";